/**
 * Extended Banner – slideshow + YouTube/Vimeo background videos
 */
(function () {
  'use strict';

  function parseYouTubeId(url) {
    if (!url) return null;
    const match = url.match(
      /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    );
    return match ? match[1] : null;
  }

  function parseVimeoId(url) {
    if (!url) return null;
    const match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return match ? match[1] : null;
  }

  function buildYouTubeSrc(id) {
    const params = new URLSearchParams({
      autoplay: '1',
      mute: '1',
      loop: '1',
      playlist: id,
      controls: '0',
      showinfo: '0',
      rel: '0',
      playsinline: '1',
      modestbranding: '1',
      iv_load_policy: '3',
    });
    return `https://www.youtube.com/embed/${id}?${params.toString()}`;
  }

  function buildVimeoSrc(id) {
    const params = new URLSearchParams({
      autoplay: '1',
      muted: '1',
      loop: '1',
      background: '1',
      transparent: '0',
      title: '0',
      byline: '0',
      portrait: '0',
    });
    return `https://player.vimeo.com/video/${id}?${params.toString()}`;
  }

  function pauseSlideMedia(slide) {
    if (!slide) return;
    slide.querySelectorAll('video').forEach((video) => {
      video.pause();
    });
    slide.querySelectorAll('iframe').forEach((iframe) => {
      iframe.src = iframe.dataset.src || iframe.src;
    });
  }

  function playSlideMedia(slide) {
    if (!slide) return;
    slide.querySelectorAll('video').forEach((video) => {
      video.muted = true;
      video.play().catch(() => {});
    });
    slide.querySelectorAll('iframe[data-src]').forEach((iframe) => {
      if (!iframe.src || iframe.src === 'about:blank') {
        iframe.src = iframe.dataset.src;
      }
    });
  }

  function initBanner(banner) {
    if (!banner || banner.dataset.ebInitialized === 'true') return;
    banner.dataset.ebInitialized = 'true';

    const slides = Array.from(banner.querySelectorAll('[data-eb-slide]'));
    const dots = Array.from(banner.querySelectorAll('[data-eb-dot]'));
    const prevBtn = banner.querySelector('[data-eb-prev]');
    const nextBtn = banner.querySelector('[data-eb-next]');
    const autoplay = banner.dataset.autoplay === 'true';
    const duration = (parseInt(banner.dataset.duration, 10) || 6) * 1000;

    if (slides.length === 0) return;

    let current = slides.findIndex((s) => s.classList.contains('is-active'));
    if (current < 0) current = 0;

    let timer = null;

    const goTo = (index) => {
      const next = (index + slides.length) % slides.length;
      if (next === current) return;

      pauseSlideMedia(slides[current]);
      slides[current].classList.remove('is-active');
      dots[current]?.classList.remove('is-active');

      current = next;
      slides[current].classList.add('is-active');
      dots[current]?.classList.add('is-active');
      playSlideMedia(slides[current]);
    };

    const next = () => goTo(current + 1);
    const prev = () => goTo(current - 1);

    const startAutoplay = () => {
      if (!autoplay || slides.length < 2) return;
      stopAutoplay();
      timer = setInterval(next, duration);
    };

    const stopAutoplay = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        goTo(i);
        startAutoplay();
      });
    });

    prevBtn?.addEventListener('click', () => {
      prev();
      startAutoplay();
    });

    nextBtn?.addEventListener('click', () => {
      next();
      startAutoplay();
    });

    banner.addEventListener('mouseenter', stopAutoplay);
    banner.addEventListener('mouseleave', startAutoplay);

    playSlideMedia(slides[current]);
    startAutoplay();

    banner._ebDestroy = () => {
      stopAutoplay();
      pauseSlideMedia(slides[current]);
    };
  }

  function initIframeSources(banner) {
    banner.querySelectorAll('[data-eb-youtube]').forEach((el) => {
      const id = parseYouTubeId(el.dataset.ebYoutube);
      if (!id) return;
      const iframe = el.querySelector('iframe');
      if (iframe) iframe.dataset.src = buildYouTubeSrc(id);
    });

    banner.querySelectorAll('[data-eb-vimeo]').forEach((el) => {
      const id = parseVimeoId(el.dataset.ebVimeo);
      if (!id) return;
      const iframe = el.querySelector('iframe');
      if (iframe) iframe.dataset.src = buildVimeoSrc(id);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-extended-banner]').forEach((banner) => {
      initIframeSources(banner);
      initBanner(banner);
    });
    document.dispatchEvent(new CustomEvent('extended-banner:loaded'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const banner = event.target.querySelector('[data-extended-banner]');
    if (banner) {
      initIframeSources(banner);
      initBanner(banner);
      document.dispatchEvent(new CustomEvent('extended-banner:loaded'));
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const banner = event.target.querySelector('[data-extended-banner]');
    if (banner?._ebDestroy) banner._ebDestroy();
  });
})();
